import { InputProps } from "@mui/material";
import { TextInput,TextInputProps } from "../Input/TextInput";

interface TextAreaProps extends TextInputProps {
  isBorder?: boolean;
  backgroundColor?: string;
  borderColor?: string;
}

export default function TextArea({ isBorder, ...props }: TextAreaProps) {
  return (
    <TextInput multiline minRows={3} fullWidth {...props} isBorder={isBorder} />
  );
}
